import { useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import "../styles/Dashboard.css"; // Reaproveita os estilos globais e de modal

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      navigate("/dashboard");
    } catch (err) {
      alert("Usuário ou senha inválidos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal" style={{ background: "#2c3e50" }}>
      <form onSubmit={handleSubmit} className="modal-content" style={{ width: "350px" }}>
        <h2 style={{ marginBottom: "20px", color: "#2c3e50" }}>🔑 Login</h2>

        <div style={{ textAlign: "left", width: "100%" }}>
          <label style={{ fontSize: "14px", fontWeight: "bold" }}>Usuário</label>
          <input
            placeholder="Digite seu usuário"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            style={{ marginBottom: "15px", width: "100%", display: "block" }}
          />
        </div>

        <div style={{ textAlign: "left", width: "100%" }}>
          <label style={{ fontSize: "14px", fontWeight: "bold" }}>Senha</label>
          <input
            type="password"
            placeholder="Digite sua senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ marginBottom: "20px", width: "100%", display: "block" }}
          />
        </div>

        <div className="modal-actions" style={{ flexDirection: "column", gap: "10px" }}>
          <button 
            type="submit" 
            className="btn" 
            style={{ backgroundColor: "#3498db", color: "white", width: "100%", padding: "12px" }}
            disabled={loading}
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
          
          <p style={{ fontSize: "14px", marginTop: "10px" }}>
            Não tem uma conta? <Link to="/register" style={{ color: "#3498db", fontWeight: "bold", textDecoration: "none" }}>Cadastre-se</Link>
          </p>
        </div>
      </form>
    </div>
  );
}

export default Login;